import React, { useEffect, useState, useCallback } from 'react';

import callApi from '../../utils/callApi';
import { WORDPRESS_PRODUCTS } from '../../constants/apiUrls/apiUrls';

import styles from './css/GuestShopSection.module.css';


const formatPrice = (price) => {
  const priceString = price.toString();
  const middle = priceString.length - 2;
  const digitsAfterDecimal = priceString.split('').splice(middle, 2);
  const digitsBeforeDecimal = priceString.split('').splice(0, middle);

  return `${digitsBeforeDecimal.join('')}.${digitsAfterDecimal.join('')}`;

};

function GuestHomeShopSection() {
  const [products, setProducts] = useState([]);

  const getWordpressProducts = () => {
    callApi(
      WORDPRESS_PRODUCTS,
      'get',
      {},
      {},
      {},
      false,
      false).then((res) => {
      setProducts(res?.data?.slice(0, 5));
    }).catch(() => {
      setProducts([]);
    });
  };

  useEffect(() => {
    getWordpressProducts();
  }, []);

  const renderProductItem = useCallback((item) => (
    <span key={item.id} className={styles.shopItemContainer}>
      <a className={styles.shopItemLink} href={item.permalink} rel="noreferrer" target="_blank">
        <div className={styles.shopItemImageContainer}>
          <img alt={item.name} className={styles.shopItemImage} src={item.images[0].src} />
          <div className={styles.shopItemCaption}>
            <p className={styles.shopItemName}>{item.name}</p>
            <p className={styles.shopItemCurrency}>
              ${`${formatPrice(item.prices.price)} ${item.prices.currency_code}`}
            </p>
          </div>
        </div>
      </a>
    </span>
  ), []);

  return (
    <div className={styles.guestHomeShopContainer} style={{ minHeight: 320 }}>
      {products.map(renderProductItem)}
    </div>
  );
}

export default React.memo(GuestHomeShopSection);
